exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.message-container .message-wrapper[data-v-02bf325c] {\n  background-color: white;\n}\n.message-container .message-wrapper section[data-v-02bf325c] {\n    text-align: left;\n}\n.message-container .message-content[data-v-02bf325c] {\n  margin-top: 8px;\n}\n.main-message[data-v-02bf325c] {\n  margin-top: 8px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-02bf325c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/organisms/chatbot/modals/ModalEditMessageParts.vue
// module id = zOze
// module chunks = 3